<template>
  <Transition
    appear
    enter-active-class="transition-all duration-300 ease-out"
    enter-from-class="opacity-0 translate-y-20"
  >
    <div class="flex w-200 shrink-0 flex-row items-center gap-8">
      <div
        v-if="isIcon"
        class="border-static-default-low rounded-sm flex size-40 shrink-0 justify-center border-1"
      >
        <component
          :is="icons[image]"
          class="flex self-center"
          :height="24"
          size="24"
          :width="24"
        />
      </div>
      <RevIllustration
        v-else
        alt=""
        class="border-static-default-low rounded-sm border-1"
        :height="40"
        sizes="40px"
        :src="image"
        :width="40"
      />

      <div class="overflow-hidden">
        <p
          class="body-2-bold text-ellipsis"
          :class="{
            'line-clamp-1': !!description,
            'line-clamp-2': !description,
          }"
        >
          {{ label }}
        </p>
        <p v-if="description" class="body-2 line-clamp-1 text-ellipsis">
          {{ description }}
        </p>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { type Component, computed } from 'vue'

import { RevIllustration } from '@ds/components/Illustration'
import { IconQuality } from '@ds/icons/IconQuality'
import { IconSwap } from '@ds/icons/IconSwap'

const icons: Record<string, Component> = {
  IconQuality,
  IconSwap,
}

const props = defineProps<{
  image: 'IconQuality' | 'IconSwap' | string
  label: string
  description?: string
}>()

const isIcon = computed(() => {
  return Object.keys(icons).includes(props.image)
})
</script>
